import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, breakpoints } from '../../../shared/styles/theme';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.neutral.gray50};
`;

export const GridTwo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${spacing.xl};

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const IncludesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${spacing.md};

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const IncludeItem = styled.div`
  background: ${colors.neutral.white};
  padding: ${spacing.lg};
  border-radius: ${borderRadius.xl};
  border: 1px solid ${colors.neutral.gray200};
  display: flex;
  align-items: center;
  gap: ${spacing.md};

  svg {
    font-size: 1.5rem;
    color: ${colors.primary.orange};
    flex-shrink: 0;
  }
`;

export const IncludeText = styled.span`
  font-size: ${typography.fontSize.base};
  font-weight: ${typography.fontWeight.semibold};
  color: ${colors.neutral.gray800};
`;

export const PlaceholderBanner = styled.div`
  background: rgba(217, 125, 43, 0.1);
  border: 1.5px dashed ${colors.primary.orange};
  border-radius: ${borderRadius.lg};
  padding: ${spacing.md};
  color: ${colors.primary.orange};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.semibold};
  text-align: center;
  margin-bottom: ${spacing.xl};
`;
